import { useAuth } from '../hooks/useAuth';

const initials = (username) => (username ? username.slice(0, 2).toUpperCase() : '?');

const ProfileView = () => {
  const { user, logout } = useAuth();
  if (!user) return null;

  return (
    <div className="md:hidden px-4 pt-8 flex flex-col items-center">
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-yellow to-brick flex items-center justify-center text-navy-dark text-2xl font-heading font-bold mb-4">
        {initials(user.username)}
      </div>
      <h2 className="font-heading font-bold text-xl text-ink-primary">{user.username}</h2>
      {user.role === 'admin' && (
        <span className="mt-2 px-2 py-0.5 bg-yellow text-navy-dark text-[10px] font-bold rounded">ADMIN</span>
      )}
      <button
        onClick={logout}
        className="mt-8 w-full max-w-xs px-4 py-3 bg-white border border-border rounded-xl text-ink-primary font-medium hover:bg-cream-bg transition-colors"
      >
        Logout
      </button>
    </div>
  );
};

export default ProfileView;
